__turbopack_context__.v({
  "details": "Donations-module__DmUtga__details",
  "empty": "Donations-module__DmUtga__empty",
  "header": "Donations-module__DmUtga__header",
});
